import { formatNumber } from "./numberFormat";

export function mostraPrezziDestinazione(destinazione) {
  const raw =
    destinazione?.datiDestinazione?.ok_assegno ?? destinazione?.ok_assegno;
  return Number(raw) === 1;
}

export function prezzoPaneVisibile(prezzo) {
  const n = Number(prezzo);
  return Number.isFinite(n) && n > 0;
}

export function formatPrezzoPane(prezzo, unita) {
  if (!prezzoPaneVisibile(prezzo)) return "";
  const um = String(unita ?? "").trim();
  const cifra = `${formatNumber(prezzo, 2)} €`;
  return um ? `${cifra} / ${um}` : cifra;
}

export function importoRigaPane(quantita, prezzo) {
  if (!prezzoPaneVisibile(prezzo)) return null;
  const q = Number(quantita);
  if (!Number.isFinite(q)) return null;
  return q * Number(prezzo);
}

export function formatImportoPane(importo) {
  if (importo === null || importo === undefined) return "";
  const n = Number(importo);
  if (!Number.isFinite(n)) return "";
  return `${formatNumber(n, 2)} €`;
}

export function mappaPrezziCatalogo(articoli) {
  const map = {};
  if (!Array.isArray(articoli)) return map;
  articoli.forEach((articolo) => {
    const codice = String(articolo?.cd_min ?? articolo?.codice ?? "").trim();
    if (!codice) return;
    map[codice] = {
      prezzo: Number(articolo.prezzo) || 0,
      tipo_prezzo: articolo.tipo_prezzo || null,
    };
  });
  return map;
}

export function arricchisciOrdineConPrezzoCatalogo(row, prezziPerCodice) {
  const codice = String(row?.codice ?? "").trim();
  const info = prezziPerCodice?.[codice];
  if (!info) return row;
  return {
    ...row,
    prezzo: info.prezzo,
    tipo_prezzo: info.tipo_prezzo,
  };
}

export function totaleGiornoPane(ordini) {
  if (!Array.isArray(ordini)) return null;
  let somma = 0;
  let almenoUno = false;
  ordini.forEach((riga) => {
    const importo = importoRigaPane(riga?.quantita, riga?.prezzo);
    if (importo === null) return;
    somma += importo;
    almenoUno = true;
  });
  return almenoUno ? somma : null;
}
